module.exports = __webpack_public_path__ + "img/S2.e8c636a6.png";